import React from "react";
import { useTranslation } from "react-i18next";
import { FunnelIcon } from "lucide-react";

export interface FilterButtonProps {
  filtersCount?: number;
  onClick?: () => void;
  className?: string;
}

export const FilterButton: React.FC<FilterButtonProps> = ({
  filtersCount = 0,
  onClick,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <button
      onClick={onClick}
      className={`relative flex items-center justify-center rounded-md border p-2 transition-colors hover:bg-muted ${className || ""}`}
      aria-label={t("chart.filters.showFilters", "Show filters")}
      title={t("chart.filters.filterTooltip", "Filter chart data")}
      data-testid="filter-button"
    >
      <FunnelIcon className="h-5 w-5 text-[var(--color-primary)]" />
      {filtersCount > 0 && (
        <div
          className="absolute -top-2 -right-2 flex h-6 w-6 items-center justify-center rounded-full border-1 border-white bg-primary text-center text-xs font-semibold text-primary-foreground"
          data-testid="filter-count"
        >
          <span className="flex items-center justify-center bg-primary text-xs text-primary-foreground">
            {filtersCount}
          </span>
        </div>
      )}
    </button>
  );
};
